<template>
  <div class="container">
    <div class="small-container">
      <h3>
        EVALUACIÓN DEL DESEMPEÑO DOCENTE - AÑO ACADÉMICO
        {{ new Date().getFullYear() - 1 }}-{{ new Date().getFullYear() }}
      </h3>
      <h4>
        BIENVENIDO AL PROCESO DE GESTIÓN DE LA EVALUACIÓN DEL DESEMPEÑO DOCENTE
        EN LAS ACTIVIDADES DE CLASES O ENCUENTROS ACADÉMICOS EN EL AÑO ACADÉMICO
        {{ new Date().getFullYear() - 1 }}-{{ new Date().getFullYear() }}
      </h4>
    </div>
    <div class="small-container">
      <h3>
        Introduzca su cédula sin puntos ni letras (12345678) y contraseña
        para verificar su existencia en el sistema, su contraseña por defecto es igual a su número de cédula. 
      </h3>
      <div class="logo-bg">
        Credenciales
        <form @submit.prevent="getUserSession" class="flex-col" method="post">
          <div class="input-row">
            <!-- <div class="form-field-cont">
              <select
                class="form-field form-ssm"
                @change="handleChange"
                v-model="usuario.nacionalidad"
              >
                <option value="" selected data-foo="V">V</option>
                <option value="" data-foo="E">E</option>
              </select>
            </div> -->
            <div class="form-field-cont">
              <font-awesome-icon icon="id-card" class="form-icon" />
              <input
                class="form-field"
                type="text"
                v-model="usuario.cedula"
                placeholder="Número de cédula"
                @keyup="clear()"
              />
            </div>
          </div>

          <div class="form-field-cont">
            <font-awesome-icon icon="lock" class="form-icon" />
            <input
              class="form-field"
              type="password"
              v-model="usuario.password"
              placeholder="Contraseña"
            />
          </div>
          <button :disabled="submit" type="submit" class="btn-blue">
            Entrar
            <font-awesome-icon
              v-if="!submit"
              icon="right-to-bracket"
            /><font-awesome-icon v-if="submit" class="loader" icon="spinner" />
          </button>
        </form>
      </div>
      <router-link
        to="recuperar-contrasena"
        class="btn"
        style="margin-block: 20px"
        ><h5>¿Olvido su contraseña?</h5></router-link
      >
    </div>
  </div>
</template>

<script>
import { createToast } from "mosha-vue-toastify";
import "mosha-vue-toastify/dist/style.css";
const axios = require("axios");
const API_URL = process.env.VUE_APP_API_URL;
export default {
  data() {
    return {
      usuario: {
        cedula: "",
        nacionalidad: "",
        password: "",
      },
      submit: false,
    };
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
  },
  created() {
    if (this.loggedIn) {
      this.$store.state.auth.usr = JSON.parse(sessionStorage.getItem("user"));
      this.checkUserType();
    }
  },
  methods: {
    userEmpty() {
      if (this.usuario.cedula == "") {
        return true;
      } else {
        return false;
      }
    },
    passwordEmpty() {
      if (this.usuario.password == "") {
        return true;
      } else {
        return false;
      }
    },
    handleChange(e) {
      if (e.target.options.selectedIndex > -1) {
        console.log(
          e.target.options[e.target.options.selectedIndex].dataset.foo
        );
      }
    },
    clear() {
      this.usuario.cedula = this.usuario.cedula.replace(/[^0-\s\d][\\\^]?/g, '')     
    },
    checkUserType() {
      if (this.loggedIn) {
        if (this.$store.state.auth.usr.persona.tipo === "Administrador") {
          this.$router.push("/panel-administrador");
        } else if (this.$store.state.auth.usr.persona.tipo === "Estudiante") {
          this.$router.push("/panel-estudiante");
        }
      }
    },
    async getUserSession() {
      if (!this.userEmpty() && !this.passwordEmpty()) {
        this.submit = true;
        await this.$store.dispatch("auth/login", this.usuario).then(
          async (response) => {
            if (response == "!No se encontro su cedula en nuestro sistema!.") {
              createToast(response, { type: "danger" });
              this.submit = false;
            } else if (response == "!Su cuenta de administrador se encuentra inactiva!.") {
              createToast(response, { type: "danger" });
              this.submit = false;
            } else if (response == "Contraseña incorrecta.") {
              createToast(response, { type: "danger" });
              this.submit = false;
            } else {
              await this.$store
                .dispatch(
                  "auth/verify",
                  JSON.parse(sessionStorage.getItem("token")).access_token
                )
                .then((res) => {
                  this.$store.state.auth.usr = JSON.parse(
                    sessionStorage.getItem("user")
                  );
                  this.checkUserType();
                })
                .catch((e) => {
                  console.log(e);
                });
            }
          },
          (error) => {
            console.log(error);
          }
        );
      } else if (this.userEmpty()) {
        createToast("Ingrese su número de cedula.", { type: "danger" });
        this.submit = false;
      } else if (this.passwordEmpty()) {
        createToast("Ingrese su contraseña.", { type: "danger" });
        this.submit = false;
      } else {
        createToast("Debe llenar todos los campos", { type: "danger" });
        this.submit = false;
      }
    },
  },
};
</script>

<style scoped>
.loader {
  animation: rotate 0.8s linear infinite;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
    filter: contrast(100%);
  }

  40% {
    transform: rotate(200deg);
    filter: contrast(100%);
  }

  100% {
    transform: rotate(360deg);
    filter: contrast(100%);
  }
}
</style>
